import { arrayOf, node, shape, string, bool } from "prop-types";

import StyledLink from "../StyledLink/StyledLink.jsx";
import VideoApiPlayer from "../VideoApiPlayer/VideoApiPlayer.jsx";

const propTypes = {
  hideFeatured: bool,
  promos: arrayOf(
    shape({
      title: string,
      description: node,
      displayTextRight: bool,
      link: string,
      linkTarget: string,
      videoId: string,
      playerType: string,
      placeholderImg: string,
    }).isRequired,
  ).isRequired,
};

const MultiPromoVideoDesktop = (props) => {
  const { hideFeatured, promos } = props;

  let featuredPromo;
  let promoList;
  if (hideFeatured) {
    promoList = promos;
  } else {
    featuredPromo = promos[0];
    promoList = promos.slice(1, promos.length);
  }

  return (
    <>
      {!hideFeatured && featuredPromo && (
        <div className="multi-promo-c__featured-promo">
          {featuredPromo.displayTextRight && (
            <div className="multi-promo-c__featured-video">
              <VideoApiPlayer
                videoId={featuredPromo.videoId}
                playerType={featuredPromo.playerType}
                placeholderImg={featuredPromo.placeholderImg}
              />
            </div>
          )}
          <div className="multi-promo-c__featured-content">
            {featuredPromo.eyebrow && (
              <div
                className="multi-promo-a__eyebrow"
                data-aos="border-grow"
                data-aos-once="true"
              >
                {featuredPromo.eyebrow}
              </div>
            )}
            <h4 className="multi-promo-c__featured-title">
              {featuredPromo.link ? (
                <StyledLink
                  href={featuredPromo.link}
                  target={featuredPromo.linkTarget}
                >
                  {featuredPromo.title}
                </StyledLink>
              ) : (
                <span>{featuredPromo.title}</span>
              )}
            </h4>
            <div
              dangerouslySetInnerHTML={{ __html: featuredPromo.description }}
            ></div>
          </div>
          {!featuredPromo.displayTextRight && (
            <div className="multi-promo-c__featured-video">
              <VideoApiPlayer
                videoId={featuredPromo.videoId}
                playerType={featuredPromo.playerType}
                placeholderImg={featuredPromo.placeholderImg}
              />
            </div>
          )}
        </div>
      )}
      <div className="multi-promo-c__promos">
        {promoList.map((promo, i) => (
          <div className="multi-promo-c__promo" key={i}>
            <div className="multi-promo-c__promo-video">
              <VideoApiPlayer
                videoId={promo.videoId}
                playerType={promo.playerType}
                placeholderImg={promo.placeholderImg}
              />
            </div>

            <h5 className="multi-promo-c__promo-title">
              {promo.link ? (
                <StyledLink href={promo.link} target={promo.linkTarget}>
                  {promo.title}
                </StyledLink>
              ) : (
                <span>{promo.title}</span>
              )}
            </h5>
            <div dangerouslySetInnerHTML={{ __html: promo.description }}></div>
          </div>
        ))}
      </div>
    </>
  );
};

MultiPromoVideoDesktop.propTypes = propTypes;
export default MultiPromoVideoDesktop;
